export default "__VITE_ASSET__CLD$EKD7__"